import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ShareWithGallery from "../component/ShareWithGallery";
import InjectScript from "../CustomScript";
import HelperScript from "../../utils/helper";
import ShareWith from "../component/ShareWith";
import Comment from "../pages/comment";
import Login from "../pages/Login";
import HomeTaboola from "./HomeTaboola";
import ReactGA from "react-ga4";
import GalleryMorePage from "./GalleryMorePage";
import { taboolacontent } from "../../ads/AdTaboolaConfig";
import { generateResizedImageUrl } from "../../utils/httpService";
const ScrollPage = ({ innerData, isScrollUpdate }) => {

  const { 99: ArticleContent } = useSelector(
    (state) => state?.widgetReducer?.data,
  );

  const timeline = useSelector((state) => state?.PostReducer?.data?.timeline);
  const [postCommentModalView, setPostCommentModalView] = useState(false);
  const [showFullContent, setShowFullContent] = useState(false);
  const hideReadMore = window.location.pathname.includes("fifa-world-cup-2026-all-the-details-from-schedule-to-timing-read-in-one-click") || (innerData?.url && innerData.url.includes("fifa-world-cup-2026-all-the-details-from-schedule-to-timing-read-in-one-click"));

  const [comCount, setcomCount] = useState(0);

  const showPostComment = useCallback(() => {
    setPostCommentModalView((prev) => !prev);
  }, []);
  const lastViewedRef = React.useRef(null);

  useEffect(() => {
    // SCROLL TO DIV BASED ON URL PARAM
    const sectionId = window.location.search.replace("?", "");

    if (sectionId && innerData?.images && !showFullContent) {
      const sectionIndex = innerData.images.findIndex(
        (img) => img.image_id.toString() === sectionId
      );
      if (sectionIndex >= 4) {
        setShowFullContent(true);
        return;
      }
    }

    let isInitialScroll = false;

    if (sectionId) {
      isInitialScroll = true;
      // Add a small delay to ensure DOM is ready

      setTimeout(() => {
        const element = document.getElementById(sectionId);

        if (element) {
          const elementRect = element.getBoundingClientRect();
          const absoluteElementTop = elementRect.top + window.pageYOffset;
          const middle = absoluteElementTop - window.innerHeight / 2 + 280; // Added 100px offset to move up from center

          window.scrollTo({
            top: middle,
            behavior: "smooth",
          });

          // Re-enable intersection observer after scroll completes
          setTimeout(() => {
            isInitialScroll = false;
          }, 1000); // Wait for smooth scroll to complete
        }
      }, 100);
    }

    // INTERSECTION OBSERVER FOR URL UPDATE
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isInitialScroll) {
            const id = entry.target.getAttribute("id");
            window.history.replaceState(null, "", `?${id}`);
            window._comscore = window._comscore || [];
            window._comscore.push({
              c1: "2",
              c2: "38736750",
              page: `${window.location.pathname}?${id}`,
            });

            // Force SPA beacon
            if (window.COMSCORE && window.COMSCORE.beacon) {
              window.COMSCORE.beacon({
                c1: "2",
                c2: "38736750",
                page: `${window.location.pathname}?${id}`,
              });
            }

            ReactGA.send({
              hitType: "pageview",
              page: `${window.location.pathname}?${id}`,
              title: "Gallery",
            });
            // console.log(`${window.location.pathname}?${id}`, "scrolllllllllll");
          }
        });
      },
      { threshold: 0.6 },
    );

    const targets = document.querySelectorAll("[data-section]");
    targets.forEach((section) => observer.observe(section));

    return () => {
      targets.forEach((section) => observer.unobserve(section));
    };
  }, [showFullContent, innerData]);


  const taboolarelatedcontent =
    "" +
    "" +
    '<div id="taboola-related-articles-widget-thumbnails"></div>' +
    '<script type="text/javascript">' +
    "window._taboola = window._taboola || [];" +
    "_taboola.push({" +
    "mode: 'thumbnails-b'," +
    "container: 'taboola-related-articles-widget-thumbnails'," +
    "placement: 'Related Articles Widget Thumbnails'," +
    "target_type: 'mix'" +
    "});" +
    "</script>" +
    "" +
    '<script type="text/javascript">' +
    "window._taboola = window._taboola || [];" +
    " _taboola.push({flush: true});" +
    "</script>" +
    "";


  const scrollUpHandler = () => {
    const currentSectionId = window.location.search.replace("?", "");
    const currentIndex = innerData?.images?.findIndex(
      (img) => img.image_id.toString() === currentSectionId,
    );
    if (currentIndex > 0) {
      const prevImage = innerData?.images[currentIndex - 1];
      const element = document.getElementById(prevImage?.image_id);
      if (element) {
        const elementRect = element.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const middle = absoluteElementTop - window.innerHeight / 2 + 280;

        window._comscore = window._comscore || [];
        window._comscore.push({
          c1: "2",
          c2: "38736750",
          page: `${window.location.pathname}?${prevImage.image_id}`,
        });

        // Force SPA beacon
        if (window.COMSCORE && window.COMSCORE.beacon) {
          window.COMSCORE.beacon({
            c1: "2",
            c2: "38736750",
            page: `${window.location.pathname}?${prevImage.image_id}`,
          });
        }

        ReactGA.send({
          hitType: "pageview",
          page: `${window.location.pathname}?${prevImage.image_id}`,
          title: "Gallery",
        });
        window.history.replaceState(null, "", `?${prevImage.image_id}`);
      }
    }
  };

  const scrollDownHandler = () => {
    const currentSectionId = window.location.search.replace("?", "");
    const currentIndex =
      innerData?.images?.findIndex(
        (img) => img.image_id.toString() === currentSectionId,
      ) || 0;

    if (currentIndex < innerData?.images?.length - 1) {
      const nextImage = innerData?.images[currentIndex + 1];
      const element = document.getElementById(nextImage?.image_id);
      if (element) {
        const elementRect = element.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const middle = absoluteElementTop - window.innerHeight / 2 + 280;
        window._comscore = window._comscore || [];
        window._comscore.push({
          c1: "2",
          c2: "38736750",
          page: `${window.location.pathname}?${nextImage.image_id}`,
        });

        // Force SPA beacon
        if (window.COMSCORE && window.COMSCORE.beacon) {
          window.COMSCORE.beacon({
            c1: "2",
            c2: "38736750",
            page: `${window.location.pathname}?${nextImage.image_id}`,
          });
        }
        ReactGA.send({
          hitType: "pageview",
          page: `${window.location.pathname}?${nextImage.image_id}`,
          title: "Gallery",
        });
        window.scrollTo({
          top: middle,
          behavior: "smooth",
        });

        // Update URL
        window.history.replaceState(null, "", `?${nextImage.image_id}`);
      }
    }
  };

  const setCountCom = (c) => {
    setcomCount(c);
  };
  return (
    <>
      <section className="GalleryInner" id="myGalleyImg0">
        <div className="container my-4">
          <div className="row">
            <div className="col-md-1    ">
              <div className="left-icon-fixed displaynone">
                <ShareWithGallery
                  key={window.location.href}
                  url={window.location.href}
                  title={document.title}
                  dataid={innerData?.id}
                />
                <div className="left-icon-fixed-up-down mt-5">
                  <p
                    onClick={scrollUpHandler}
                    className="left-icon-border mt-4"
                  >
                    <i className="fas fa-chevron-up left-fixed-icon-border"></i>
                  </p>
                  <p className="left-icon-border" onClick={scrollDownHandler}>
                    <i className="fas fa-chevron-down left-fixed-icon-border"></i>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="shadow p-3 mb-3 bg-white rounded">
                <h1 className="gallery-head-title">{innerData?.title}</h1>
                <div className="post-content-gallery">
                  {ArticleContent?.[0]?.script ? (
                    <InjectScript
                      script={(innerData?.short_description?.trim()
                        ? innerData.short_description
                        : innerData?.content
                      )
                        ?.replace(/<p([^>])>(.?)<\/p>/i, "<h2$1>$2</h2>")
                        ?.replace("[[$ad]]", ArticleContent?.[0]?.script)
                        ?.replace("[[$googlead]]", " ")
                        ?.replace("[[$alsoread]]", " ")}
                    />
                  ) : (
                    <InjectScript
                      script={(innerData?.short_description?.trim()
                        ? innerData.short_description
                        : innerData?.content
                      )
                        ?.replace("[[$ad]]", "")
                        ?.replace("[[$googlead]]", " ")
                        ?.replace("[[$alsoread]]", " ")}
                    />
                  )}
                </div>
              </div>
              {innerData?.images?.map((img, index) => (
                <React.Fragment key={img.image_id}>
                  {(index < 4 || showFullContent || hideReadMore) && (
                    <div
                      id={`${img.image_id}`}
                      data-section
                      style={
                        {
                          // height: "70vh",
                        }
                      }
                    >
                      <>
                        <div
                          className="card mb-3 scrollValue"
                          id={`myGalleyImg${index + 1}`}
                          data-index={index + 1}
                        >
                          <span className="sticky-num">
                            {index + 1}
                            <em>/{innerData?.images?.length}</em>
                          </span>
                          <img
                            loading="lazy"
                            className="card-img-tops"
                            src={generateResizedImageUrl(651, 366, img?.media)}
                            alt={img?.media_title}
                          />
                        </div>
                        <p
                          className="mb-2 mt-2"
                          style={{ fontSize: "17px" }}
                          dangerouslySetInnerHTML={{
                            __html: img.content,
                          }}
                        />
                      </>
                    </div>
                  )}

                  {index === 3 &&
                    !showFullContent &&
                    !hideReadMore &&
                    innerData?.images?.length > 4 && (
                      <div className="read-more-wrapper mb-3">
                        <div style={{ position: "relative" }}>
                          {/* Blur Overlay */}
                          <div
                            style={{
                              position: "absolute",
                              bottom: "40px",
                              left: 0,
                              width: "100%",
                              height: "40px",
                              backdropFilter: "blur(1px)",
                              WebkitBackdropFilter: "blur(1px)",
                              background:
                                "linear-gradient(to bottom, rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 1))",
                              pointerEvents: "none",
                              zIndex: 1,
                            }}
                          ></div>

                          {/* Read More Button */}
                          <button
                            onClick={() => {
                              setShowFullContent(true);
                              ReactGA.send({
                                hitType: "pageview",
                                page: window.location.pathname + window.location.search,
                                title: "Article Page",
                              })
                            }}
                            type="button"
                            className="py-4 font-normal text-sm relative overflow-visible w-100"
                            style={{
                              border: "none",
                              color: "#ae0a0b",
                              backgroundColor: "white",
                              position: "relative",
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              boxShadow:
                                "0 16px 15px rgba(255, 255, 255, 0.1), 0 12px 8px rgba(250, 250, 250, 0.08)",
                              padding: "8px 25px",
                              height: "50px",
                            }}
                          >
                            <span
                              style={{
                                position: "absolute",
                                left: 0,
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: "100%",
                                height: "2px",
                                backgroundColor: "#ae0a0b",
                                zIndex: 2,
                              }}
                            ></span>
                            <span
                              style={{
                                position: "relative",
                                zIndex: 3,
                                backgroundColor: "#ffffff",
                                padding: "6px 30px",
                                color: "#333333",
                                fontWeight: "bold",
                                borderRadius: "50px",
                                border: "2px solid #ae0a0b",
                              }}
                            >
                              વધુ વાંચો
                            </span>
                          </button>
                        </div>
                      </div>
                    )}
                </React.Fragment>
              ))}
              <GalleryMorePage innerData={innerData} isScrollUpdate={isScrollUpdate} />
            </div>
            <div className="col-md-3" >
              <div className="gallery_ads1_anymind"></div>
            </div>
            <div className="col-md-2" >
              <div className="gallery_ads2_anymind"></div>
            </div>
          </div>
          {timeline?.length > 0 &&
            timeline?.map((els, idx) => (
              <div className="live-blog">
                <div className="text-left">
                  <p className="live-blog-time">{els.date}</p>
                  {/* <div className='live-blog-title' dangerouslySetInnerHTML={{ __html: els?.message }}></div> */}
                  <div className="live-blog-title asd">
                    <InjectScript script={els?.message} />
                  </div>
                </div>
              </div>
            ))}

          {/* <div className='post-sharer' dangerouslySetInnerHTML={{ __html: sharerMsg?.value }} /> */}
          <div className={`post-sharer article-${innerData?.id}`}>
            {/* <div className="ads_new_styling M-R_banner_Subhome" style={{ backgroundColor: "pink", height: "250px", width: "300px" }}>
              <div id="ub-banner-a-4"></div>
            </div> */}
          </div>
          <div className="d-flex justify-content-end social-post">
            <p className="social-share-text">Share With:</p>
            <ShareWith
              key={innerData?.id}
              url={innerData?.url}
              title={innerData?.title}
              dataid={innerData?.id}
              media={innerData?.media}
            />
          </div>
          <hr className="m-0" />
          <div className="mb-3 mt-3 text-center">
            {innerData?.comment_status === 1 && (
              <button
                onClick={() => {
                  showPostComment();
                }}
                type="button"
                className="btn btn-color mt-3"
              >
                Post a comment {comCount > 0 ? `(${comCount})` : null}
              </button>
            )}
          </div>
          <div className="row">
            {/* <div className="col-md-1"></div> */}
            <div className="col-md-9">
              <div className="single-blog mt-3">
                {/* <span className="badge badge-warning">Related Gallery</span> */}
                <div className="bottom-taboola" key={window.location.href}>
                  <InjectScript
                    type="taboola"
                    script={taboolarelatedcontent}
                    key={window.location.href}
                  />
                </div>
              </div>
              <HomeTaboola key={Math.random()} />
            </div>
            <div className="col-md-3">
              <div className="my-4 sidebar-taboola" key={window.location.href}>
                <InjectScript
                  type="taboola"
                  script={taboolacontent}
                  key={window.location.href}
                />
                <HelperScript argLarge={261} />
                {/* {
                                    window.innerWidth < 991 ?
                                    <InjectScript script={galleryinner261} />
                                    :
                                    ''
                                } */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {localStorage.getItem("access_token") ? (
        <>
          {postCommentModalView && (
            <Comment
              postCommentModalchk={showPostComment}
              postCommentcount={setCountCom}
              postId={innerData?.id}
              innerDataProps={innerData && innerData}
            />
          )}
        </>
      ) : (
        <>{postCommentModalView && <Login />}</>
      )}
    </>
  );
};

export default ScrollPage;
